const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

const trimSlashes = (value: string) => value.replace(/^\/+|\/+$/g, "");
const trimLeadingSlashes = (value: string) => value.replace(/^\/+/, "");

export const isAbsoluteUrl = (value?: string) =>
  Boolean(value && ABSOLUTE_URL_PATTERN.test(value));

export const buildApiRequestUrl = ({
  baseUrl,
  endpointPrefix,
  id,
  endpointSuffix,
}: {
  baseUrl: string;
  endpointPrefix?: string;
  id?: string;
  endpointSuffix?: string;
}) => {
  const normalizedPrefix = endpointPrefix ? trimSlashes(endpointPrefix) : "";
  const normalizedId = id ? trimSlashes(id) : "";
  const normalizedSuffix = endpointSuffix
    ? trimLeadingSlashes(endpointSuffix)
    : "";

  if (isAbsoluteUrl(endpointPrefix)) {
    return [normalizedPrefix, normalizedId, normalizedSuffix]
      .filter(Boolean)
      .join("/");
  }

  return [baseUrl, normalizedPrefix, normalizedId, normalizedSuffix]
    .filter(Boolean)
    .join("/");
};
